module.exports = __webpack_public_path__ + "static/media/masjid1.1dc09b20.jpg";